import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ReverseEngineer from "@/pages/ReverseEngineer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<ReverseEngineer />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
